import { uploadMultiBase64ToS3 } from "../../../utils/s3Uploading";
import { addToast, TOAST_TYPES } from "../../toasts";

export const createUploadHandler = async ({
  formInstance,
  responseData,
  dispatch,
}) => {
  try {
    let urls = [];
    let files = [];

    // errand report_files
    const errandReportImages = formInstance?.report_files;
    const errandReportPutUrls = responseData?.report_files?.map(
      (f) => f?.file?.put
    );

    if (errandReportImages?.length) {
      errandReportPutUrls.forEach((url, index) => {
        const image = errandReportImages?.[index];

        if (image?._tempData && url) {
          urls.push(url);
          files.push(image?._tempData?.data);
        }
      });
    }

    // errand completion_files
    const errandImages = formInstance?.completion_files;
    const errandImagesPutUrls = responseData?.completion_files?.map(
      (f) => f?.file?.put
    );

    if (errandImages?.length) {
      errandImagesPutUrls.forEach((url, index) => {
        const image = errandImages?.[index];

        if (image?._tempData && url) {
          urls.push(url);
          files.push(image?._tempData?.data);
        }
      });
    }

    //errand execution rating file
    const errandRatingFile =
      formInstance?.execution_rating?.file?._tempData?.data;

    const errandRatingFilePutUrl = responseData?.active_rating?.file?.put;

    if (errandRatingFile && errandRatingFilePutUrl) {
      urls.push(errandRatingFilePutUrl);
      files.push(errandRatingFile);
    }

    // cost files
    let costFiles = [];
    const reportPutUrls =
      responseData?.costs?.map((c) => c?.evidence?.put) || [];

    if (formInstance.costs?.length) {
      formInstance.costs.forEach((c, index) => {
        const currentPutUrl = reportPutUrls[index];

        if (c.evidenceData_ && !!currentPutUrl) {
          costFiles.push(c.evidenceData_);
          urls.push(reportPutUrls[index]);
        }
      });
    }

    if (!urls.length) {
      return;
    }

    await uploadMultiBase64ToS3({
      signedUrls: urls,
      files: files,
    });
    return;
  } catch (e) {
    dispatch(
      addToast({
        type: TOAST_TYPES.ERROR,
        title: "Filuppladdning misslyckades",
      })
    );
    return;
  }
};
